// MyFilter.js
import Vue from 'vue'
import {role} from "@/components/mock/base/const.js";
Vue.filter('roleFilter', value => {
  if (value === role.role_admin) {
    return '管理者'
  } else if (value === role.role_headOffice) {
    return '本社'
  } else if (value === role.role_headOffice_sales) {
    return '本社(業務委託)'
  } else if (value === role.role_headOffice_division) {
    return '本社(企業検診グループ)'
  } else if (value === role.role_headOffice_sw) {
    return '本社(マーケSW)'
  } else if (value === role.role_salesOffice) {
    return '営業所'
  } else if (value === role.role_psc) {
    return 'PSC'
  } else if (value === role.role_kawagoe) {
    return '川越'
  } else if (value === role.role_hospital) {
    return '医療機関'
  } else if (value === role.role_corporation) {
    return '企業'
  } else if (value === role.role_dealer) {
    return 'ディーラー'
  } else if (value === role.role_dealer_facility) {
    return 'ディーラー契約施設'
  } else if (value === role.role_judgment) {
    return '判定医療機関'
  } else if (value === role.role_holter_judgment) {
    return 'ホルター判定医療機関'    
  } else if (value === role.role_analysis) {
    return '解析委託業者'    
  } else if (value === role.role_accommodations) {
    return '宿泊施設'
  } else if (value === role.role_kawagoe_cpap) {
    return '川越(CPAP)'
  } else if (value === role.role_call_center) {
    return 'コールセンター'
  } else if (value === role.role_headOffice_call) {
    return 'コールセンター管理者'
  } else if (value === role.role_ndss) {
    return 'NDSS'
  } else {
    return 'N/A'
  }
})
Vue.filter('kindFilter', value => {
  if (value === "total") {
    return '合計'
  } else if (value === "hst") {
    return 'HST'
  } else if (value === "kenshin") {
    return '検診'
  }
})
Vue.filter('internalStatusFilter', value => {
  switch (value) {
    case 1:
      return "検査依頼中";
    case 2:
      return "機器準備中";
    case 3:
      return "出荷準備中";
    case 4:
      return "検査中";
    case 5:
      return "機器受領中";
    case 6:
      return "解析依頼中";
    case 7:
      return "解析中";
    case 8:
      return "結果確認中";
    case 9:
      return "結果送付待ち";
    case 10:
      return "川越受付中";
    case 11:
      return "判定依頼中";
    case 12:
      return "完了";
    case 13:
      return "売上計上中";
    case 14:
      return "完了（計上済）";
    case 15:
      return "再検査調整中";
    case 16:
      return "キャンセル";
    default:
      return "";
  }
})
Vue.filter('externalStatusFilter', value => {
  switch (value) {
    case 1:
    case 6:
    case 10:
      return "依頼中";
    case 2:
    case 3:
    case 4:
    case 5:
    case 9:
    case 11:
      return "検査中";
    case 7:
    case 8:
      return "解析中";
    case 12:
    case 13:
    case 14:
      return "完了";
    case 15:
      return "再検査調整中";
    case 16:
      return "キャンセル";
    default:
      return "";
  }
})
Vue.filter('coInternalStatusFilter', value => {
  switch (value) {
    case 1:
      return "申込中 (保留中)";
    case 2:
      return "登録済";
    case 3:
      return "キャンセル";
    case 5:
      return "申込中 (確認済)";
    case 6:
      return "証明書手続き中";
            
    default:
      return "";
  }
});
Vue.filter('coExternalStatusFilter', value => {
  switch (value) {
    case 1:
    case 5:
    case 6:
    return "申込中";
    case 2:
      return "登録済";
    case 3:
      return "キャンセル";
    default:
      return "";
  }
});
Vue.filter('coOrderTypeFilter', value => {
  switch (value) {
    case "1":
      return "施設登録";
    case "2":
      return "施設変更";
    case "3":
      return "ユーザー追加";
    case "4":
      return "ユーザー変更";
    case "5":
      return "ユーザー削除";
    default:
      return "";
  }
})
import {extUserStatus} from "@/components/mock/base/const.js";
import {extUserStatusStr} from "@/components/mock/base/const.js";
Vue.filter('extUserStatusFilter', value => {
  switch (value) {
    case extUserStatus.tempReg:
      return extUserStatusStr.tempReg;
    case extUserStatus.brunchReview:
      return extUserStatusStr.brunchReview;
    case extUserStatus.registed:
      return extUserStatusStr.registed;
    case extUserStatus.addRequest:
      return extUserStatusStr.addRequest;
    default:
      return "";
  }
})


// WEBPACK FOOTER //
// ./src/filters.js